import React, { Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import avatar from 'components/assets/img/pic/avatar/julia.jpg';
import Rating from 'react-rating';
import starEmpty from 'components/assets/img/icons/star-empty.svg';
import starFull from 'components/assets/img/icons/star-full.svg';
import T from 'components/common/translations/Translate';
import TransHelper from 'components/common/translations/TransHelper';
import { connect } from 'react-redux';
import {
  setReservationToReview,
  hideReviewFormInReservation,
  createSuccessNotification,
  createErrorNotification,
  overrideReservation
} from 'components/actions/serviceActions';
import axios from 'components/AppRequest';
import * as STATUES from 'components/common/constants/reservationStatusConstants';
import mergeErrors from 'components/helpers/mergeErrors';
import merge from 'lodash/merge';
import FlightHelper from 'components/common/helpers/FlightHelper';
import classNames from 'classnames';
import resizer from 'components/common/Resizer';

class Slide extends React.Component {

  constructor() {
    super();
    this.state = {
      readonly: false,
      value: null,
      comment: '',
      slideOpen: true,
      slideOpenFull: false,
    };
  }

  componentDidUpdate(prevProps) {
    //check is open
    if (prevProps.reservation === null && this.props.reservation !== null) {
      this.setState({ readonly: false, value: null, comment: '' });
    }
  }

  trans = (key) => {
    return TransHelper.translate(this.props.locale, 'content.dashboard.slider.' + key);
  }

  slideHide = () => {
    this.hideRateFormRequest();
    this.props.setReservationToReview(null);
    this.setState({
      slideOpen: false,
      slideOpenFull: false,
    });
  }

  ratingCall = (rate) => {
    if (rate < 3) {
      this.setState({
        slideOpen: false,
        readonly: true,
        slideOpenFull: true,
        value: rate
      });
    } else {
      this.setState({
        slideOpen: true,
        slideOpenFull: false,
        readonly: true,
        value: rate
      }, () => {
        if (rate > 2) {
          this.sendRequest();
        }
      });
    }
  }

  changeComment = (e) => {
    this.setState({ comment: e.target.value });
  }

  saveReview = (e) => {
    e.preventDefault();
    if (this.state.value < 3) {
      var comment = this.state.comment.trim();
      if (comment.length > 0) {
        this.sendRequest();
      } else {
        this.props.createErrorNotification({
          title: this.t('content.notifications.reviews.error'),
          message: this.t('content.notifications.reviews.noComment'),
        });
      }
    }
  }

  hideRateFormRequest() {
    var id = this.props.reservation.id;
    if (this.props.reservation.hide_rate_form) {
      //already set as hide in panel
      this.props.hideReviewFormInReservation(id);
    } else {
      axios.post('/pwa/reservation/hide-rate-form/' + id)
        .then(response => {
          this.props.hideReviewFormInReservation(id);
        })
        .catch(err => {
          console.log("err", err);
        });
    }
  }

  sendRequest = () => {
    var params = {
      data: {
        id: this.props.reservation.id,
        rate: this.state.value,
        comment: this.state.comment
      }
    };
    axios.post('/pwa/reservation/rate', params)
      .then(response => {
        this.props.createSuccessNotification({
          message: this.t('content.notifications.reviews.success'),
        });
        var reservation = merge({}, this.props.reservation);
        reservation.status = STATUES.STATUS_COMPLETED_AND_REVIEWED;
        reservation.driver_rate = params.data.rate;
        this.props.overrideReservation(reservation);
        this.props.setReservationToReview(null);
      })
      .catch(err => {
        this.props.createErrorNotification({
          title: this.t('content.notifications.reviews.error'),
          message: mergeErrors(err.response.data.errors)
        });
        console.log("err", err);
      });
  }

  t = (key) => {
    return TransHelper.translate(this.props.locale, key);
  }

  render() {
    const { locale, reservation } = this.props;
    const { slideOpen, slideOpenFull } = this.state;
    var isMobile = this.props.windowWidth < 640;
    var flightHelper;
    if (reservation) {
      flightHelper = new FlightHelper(
        reservation.flight,
        locale,
        reservation.reservation_direction
      );
    }

    return (
      <Fragment>
        {reservation &&
          <div id="slide" className={classNames(
            'slide', {
              'slide--open': isMobile || slideOpen,
              'slide--open-full': slideOpenFull,
            })}>
            <section>
              <div className="rating-header">
                <div className="rating-header__desc">
                  <h3>
                    {TransHelper.translate(
                      locale,
                      'content.dashboard.slider.title',
                      { driverName: reservation.driver_name }
                    )}
                  </h3>
                  <p className="rating-header__date">
                    {TransHelper.translate(
                      locale,
                      'content.dashboard.slider.desc',
                      {
                        date: flightHelper.getFlightDateAsString(locale),
                        from: flightHelper.getFrom(),
                        to: flightHelper.getTo()
                      }
                    )}
                  </p>
                </div>
                <div className="rating-header__image">
                  <figure style={{ visibility: 'hidden' }}>
                    <img src={avatar} alt="Julia" />
                  </figure>
                </div>
              </div>
              <div className="slide__content">
                <div className="rating-wrap">
                  <Rating
                    emptySymbol={<img src={starEmpty} className="rating__icon" />}
                    fullSymbol={<img src={starFull} className="rating__icon" />}
                    onClick={this.ratingCall}
                    readonly={this.state.readonly}
                    initialRating={this.state.value}
                  />
                </div>

                <div className="rating-content">
                  <p><T>content.dashboard.slider.content</T></p>

                  <textarea
                    placeholder={this.trans('textAreaPlaceholder')}
                    onChange={this.changeComment}
                    value={this.state.comment}
                  />
                  <button
                    className="button button--expand button--outline button--invert"
                    onClick={this.saveReview}
                  >
                    <T>content.dashboard.slider.addReview</T>
                  </button>
                </div>
              </div>

              <button
                className="button--icon button--close"
                onClick={this.slideHide}
                title="Close review"
              >
                <FontAwesomeIcon
                  icon={['fas', 'times']}
                  size="lg"
                />
              </button>
            </section>
          </div>
        }
      </Fragment>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    locale: state.app.locale,
    reservation: state.service.reservationToReview
  }
}

export default resizer(connect(
  mapStateToProps,
  {
    setReservationToReview, hideReviewFormInReservation, overrideReservation,
    createSuccessNotification, createErrorNotification
  }
)(Slide));
